var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 15.367C3.84171 15.5622 4.15829 15.5622 4.35355 15.367L7.53553 12.185C7.7308 11.9897 7.7308 11.6731 7.53553 11.4779C7.34027 11.2826 7.02369 11.2826 6.82843 11.4779L4 14.3063L1.17157 11.4779C0.976311 11.2826 0.659728 11.2826 0.464466 11.4779C0.269204 11.6731 0.269204 11.9897 0.464466 12.185L3.64645 15.367ZM3.5 0.922852L3.5 15.0134H4.5L4.5 0.922852L3.5 0.922852Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrow);
export default __webpack_public_path__ + "static/media/sorting-arrow.6f7d4603d5b76929230d1f8d540e2770.svg";
export { ForwardRef as ReactComponent };